// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_rgb","image":"az_sgb","description":"az_tgb"};